import map from 'lodash/map'
import React from 'react'
import { useContext } from './Context'
import { BoardCard } from './BoardCard'
import { Col, Row } from 'react-bootstrap'
import { AccountContainer } from '../../AccountContainer'
import { EmptyContent } from '../EmptyContent'
import { DataSuspense } from '@ztechapps/webui.util'
import { PageTitle } from '../../../../components/PageTitle'

export const Layout = () => {
  const { hasBoards, loading, error, list } = useContext()
  return (
    <AccountContainer>
      <PageTitle
        title="My Project Boards and Favorites"
        description="View and manage your saved project boards, favorites, and designs"
      />
      <DataSuspense error={error} loading={loading} isEmpty={!hasBoards} emptyComponent={<EmptyContent />}>
        <Row>
          {map(list, (board) => (
            <Col xl={4} md={6} lg={4} className="my-1" key={board?._id}>
              <BoardCard board={board} />
            </Col>
          ))}
        </Row>
      </DataSuspense>
    </AccountContainer>
  )
}
